"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getImplicitDrillsWithPredicates = void 0;
var tslib_1 = require("tslib");
// (C) 2020-2021 GoodData Corporation
var compact_1 = tslib_1.__importDefault(require("lodash/compact"));
var sdk_backend_spi_1 = require("@gooddata/sdk-backend-spi");
var sdk_model_1 = require("@gooddata/sdk-model");
var sdk_ui_1 = require("@gooddata/sdk-ui");
function widgetDrillToDrillPredicates(drill) {
    var origin;
    if (sdk_backend_spi_1.isDrillFromMeasure(drill.origin)) {
        origin = drill.origin.measure;
    }
    else if (sdk_backend_spi_1.isDrillFromAttribute(drill.origin)) {
        origin = drill.origin.attribute;
    }
    else {
        throw new sdk_backend_spi_1.UnexpectedError("Unknown drill origin!");
    }
    // add drillable items for all three types of objRefs that the origin measure can be
    return compact_1.default([
        sdk_model_1.isLocalIdRef(origin) && sdk_ui_1.HeaderPredicates.localIdentifierMatch(origin.localIdentifier),
        sdk_model_1.isIdentifierRef(origin) && sdk_ui_1.HeaderPredicates.identifierMatch(origin.identifier),
        sdk_model_1.isUriRef(origin) && sdk_ui_1.HeaderPredicates.uriMatch(origin.uri),
    ]);
}
function insightWidgetImplicitDrills(insightWidgetDrills) {
    return insightWidgetDrills.map(function (drill) {
        return {
            drillDefinition: drill,
            predicates: widgetDrillToDrillPredicates(drill),
        };
    });
}
function insightDrillDownImplicitDrills(possibleDrills, attributesWithDrillDown) {
    var drillsWitDrillDown = possibleDrills.filter(function (candidate) {
        return attributesWithDrillDown.some(function (attr) {
            return sdk_model_1.areObjRefsEqual(attr.attribute.ref, candidate.attribute.attributeHeader.formOf.ref);
        });
    });
    return drillsWitDrillDown.map(function (drill) {
        var matchingCatalogAttribute = attributesWithDrillDown.find(function (attr) {
            return sdk_model_1.areObjRefsEqual(attr.attribute.ref, drill.attribute.attributeHeader.formOf.ref);
        });
        return {
            drillDefinition: {
                type: "drillDown",
                origin: sdk_model_1.localIdRef(drill.attribute.attributeHeader.localIdentifier),
                target: matchingCatalogAttribute.attribute.drillDownStep,
            },
            predicates: [
                // add drillable items for both types of objRefs that the header can be
                sdk_ui_1.HeaderPredicates.identifierMatch(drill.attribute.attributeHeader.identifier),
                sdk_ui_1.HeaderPredicates.uriMatch(drill.attribute.attributeHeader.uri),
            ],
        };
    });
}
/**
 * Returns a collection of pairs consisting of a drill definition and all its predicates.
 *
 * @param insightWidgetDrills - drills from the insight widget itself
 * @param possibleDrills - possible drill targets returned by pushData (this contains all attributes in the visualization)
 * @param attributesWithDrillDown - all the attributes in the catalog that have drill down step defined
 */
function getImplicitDrillsWithPredicates(insightWidgetDrills, possibleDrills, attributesWithDrillDown) {
    var insightImplicitDrills = insightWidgetImplicitDrills(insightWidgetDrills);
    var drillDownImplicitDrills = insightDrillDownImplicitDrills(possibleDrills, attributesWithDrillDown);
    return tslib_1.__spreadArrays(insightImplicitDrills, drillDownImplicitDrills);
}
exports.getImplicitDrillsWithPredicates = getImplicitDrillsWithPredicates;
//# sourceMappingURL=drillingUtils.js.map